import HowlerPlayer from '/Users/skote/Documents/JS/OneHatAudio/src/Player/Howler';

export default class Howler extends HowlerPlayer {

	/**
	 * Override Player.setSong so we can unload the previous sounds
	 */
	async setSong(args) {
		if (this.debugMode) {
			console.log('ExpoAV.setSong', args);
		}

		this.wasPreviouslyPlaying = this.isPlaying;
		if (this.isPlaying) {
			await this.pause();
		}

		// unload previous sounds
		this.Howler.unload();
		
		this.settings.isLooping = this.isLooping;
		this.settings.rate = this.rate;

		await super.setSong(args);

		if (this.wasPreviouslyPlaying) {
			this.play();
		}
	}

	/**
	 * Override Player.initSong, because in this implementation, we're given a set of fileUri's,
	 * but we've used the Cache API, which uses remoteUri's.
	 * So convert the fileUri back to remoteUri, so we can get cached file,
	 * then base64 it, then put it into Howler
	 */
	async initSong(base64, isKaraoke = false) {
		if (this.debugMode) {
			console.log('Howler.initSong');
		}

		const sound = await new Promise((resolve, reject) => {
						const sound = new Howl({
							...this.settings,
							src: base64,
							onload: () => {
								console.log('Howler.onload');
								resolve(sound);
							},
							onloaderror: (id, error) => {
								console.log('Howler.onloaderror', id, error);
								reject(error);
							},
						});
					});
					// .catch((error) => {
					// 	this.emit('error', error);
					// });
		if (!sound) {
			return;
		}
		if (isKaraoke) {
			this.songSrcKaraoke = sound;
		} else {
			this.songSrc = sound;
		}
	}

}
